import firebase from 'firebase';

import * as collections from '../collectionTypes';
import { NOT_FOUND } from '../errorTypes';
import { processQuerySnapshotItems } from './utils';

const db = firebase.firestore();
const collection = db.collection(collections.NOTIFICATIONS);

export const ANY = 'any';
export const READ = 'read';
export const UNREAD = 'unread';

function getUnreadReference(uid) {
  return collection
    .where('targetUid', '==', uid)
    .where('read', '==', false)
    .orderBy('timestamp', 'desc');
}

export function get(uid, type = ANY, startAt = null, limit = 10) {
  let reference = collection
    .where('targetUid', '==', uid);

  if (type === READ) {
    reference = reference.where('read', '==', true);
  } else if (type === UNREAD) {
    reference = reference.where('read', '==', false);
  }

  reference = reference.orderBy('timestamp', 'desc');

  if (startAt) {
    reference = reference.startAt(startAt);
  }

  return reference.limit(limit)
    .get()
    .then(processQuerySnapshotItems);
}

export function watchUnread(uid, callback) {
  getUnreadReference(uid)
    .onSnapshot((querySnapshot) => {
      const notifications = [];
      querySnapshot.forEach(doc => notifications.push({ id: doc.id, ...doc.data() }));

      callback(notifications, querySnapshot);
    });
}

function markAsRead(id) {
  return collection
    .doc(id)
    .get()
    .then((doc) => {
      if (doc.exists) {
        return collection.doc(id).update({ read: true });
      }

      return Promise.reject(NOT_FOUND);
    });
}

export function markAllAsRead(uid) {
  return getUnreadReference(uid)
    .get()
    .then((querySnapshot) => {
      const promises = [];
      querySnapshot.forEach(doc => promises.push(markAsRead(doc.id)));

      return Promise.all(promises);
    });
}



// WEBPACK FOOTER //
// ./src/firebase/repositories/notifications.js